export const BUNDLE_ID_STATE_MAP = {
    'pending': 0,
    'reject': 1,
    'accept': 2,
    'building': 3,
    'done': 4,
    'deleted': 5,
    'disable': 6
};
export const AUTH_TYPE = {
    online: {
        value: 2,
        name: '联网授权'
    },
    offline: {
        value: 0,
        name: '离线打包'
    }
};

export const SDK = [
    {
        label: 'Face Liveness Detection SDK',
        value: '8',
        desc: `Face Liveness Detection SDK integrates active liveness ability and silent liveness ability.<br/>
            Action liveness: Through the action command, the user is required to complete a specific nodding, shaking his head, blinking or opening the mouth to achieve the purpose of living body detection.<br/>
            Silent liveness: The user can judge whether it is a living body without doing an action.<br/>
            Note: The algorithm can effectively prevent various security attacks, including but not limited to substitution, video, mask, remake and other means of attack.'
            `
    }
];
const stateMap = {
    0:'Under review',
    1:'Application rejected',
    6:'Terminated'
};
export function renderStateText(item){
    let state;
    let test = '';
    if(typeof item.status !== 'undefined'){
        state = item.status;
    }else{
        state = item.state;
    }

    if (state === 4) {
        const _time = item.expired_time.replace(/-/g, '/');
        const expired_date = new Date(_time), current = new Date();
        if(expired_date !== 'Invalid Date' && current > expired_date) {
            test = 'Expired';
        }else{
            test = 'In use';
        }

    }else{
        test = stateMap[state] || '';
    }
    let postponeText = '';
    if (item.extension_status === 1) {
        postponeText = '(Deferred application in progress)';
    } else if (item.extension_status === -1) {
        postponeText = '(Refusal to postpone)';
    }
    return test + postponeText;
}



// WEBPACK FOOTER //
// ./src/utils/bundleConst.js